
export const Constants = {

    backend: '/assets/content',
    sellers: 'https://essenceestoril.pt/admin/?get=sellers',
    extension: '.json',
    production: false

};
